import { render, staticRenderFns } from "./GruposList.vue?vue&type=template&id=761478a4&scoped=true"
import script from "./GruposList.vue?vue&type=script&lang=js"
export * from "./GruposList.vue?vue&type=script&lang=js"
import style0 from "./GruposList.vue?vue&type=style&index=0&id=761478a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761478a4",
  null
  
)

export default component.exports